import React from "react";

export default function PremiumRouteTransition({ children }) {
  return <div className="vg-premium-route h-full w-full">{children}</div>;
}
